<template>

  <h1 class="view-header">Construction Code AI&nbsp;Assistant</h1>

  <ScreenCaps/>

  <h2 class="page-sub-header">Trained & targeted AI for the building industry.</h2>

  <p><b>Instantly Access Construction Codes with AI-Powered Chat</b></p>
  <p>For contractors, inspectors, engineers, and regulatory professionals, Construction Code AI Assistant delivers instant, AI-driven
    answers to national, state, and region specific construction codes—without the hassle of searching through PDFs and
    government websites.</p>
  <p>AI-powered code lookup for building, plumbing, electrical, fire, mechanical and more</p>
  <p>State and Region Specific Customization – Choose only the codes relevant to your work</p>
  <p>Fast, Reliable, and Mobile-Optimized – Get answers on-site or in the office</p>
  <p>Flexible Credit-Based Pricing – Pay for what you need, when you need it</p>
  <p>Save, Share, & Report responses for easy compliance management</p>
  <p>Stop wasting time searching for compliance answers. Get Construction Code AI Assistant today!</p>
  <!--
      <p>Download on iOS & Android | 🌐 Enterprise inquiries welcome</p>
  -->

</template>

<script setup>
  import ScreenCaps from '@/components/ScreenCaps.vue'
  console.log('Component loaded:', ScreenCaps)
</script>

<script>
export default {
  name: "ConstructionCodeAIAssistant",
};
</script>
